module.exports = __webpack_public_path__ + "static/chatwithceline-7d7ad38a516ec4a9e831990e92201b73.gif";